import { FormEvent, useEffect, useState, useRef } from "react";
import "./Filter.scss";
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from "primereact/multiselect";
import { Form, useFormik } from "formik";
import { InputText } from 'primereact/inputtext';
import { FiltersInitialvalue, FiltersSchema, TestSeriesFiltersInitialvalue } from "../TestListing/Schema/Flters.schema";
import { BOARD_FILTERS, FIELD_TYPE, TEST_SERIES_FILTERS, TEST_SERIES_ALL_FILTERS, FILTER_KEYS, FILTER_LIST, SPECIFIC_TEST_SERIES_FILTERS, PREVIOUS_YEAR_TEST_SERIES_FILTERS, FULL_MOCK_TEST_SERIES_FILTERS, DIAGNOSTIC_TEST_SERIES_FILTERS } from "./Constants/filters.constants";
import { useNavigate, useLocation } from "react-router-dom";
import { DetailsRouteURL, TestSereisRouteURL } from "@Constants/app-route-url.constant";
import { getLanguageList, getBoardlist, getClassList, getUserDetails } from "../UserProfile/Services/UserProfile.sevice";
import { getDifficultyLevels, setIabhyasTestSeries } from "../TestDetails/services/TestDetails.service";
import { APIResponse, APIStatus } from "@Src/services/baseInterfaces";
import { useAppSelector, useAppDispatch } from "@App/hooks";
import { setSubscriptionData } from "@Src/app/reducers/auth/loginSlice";
import { filterEvents, FILTER_EVENTS } from "@Src/utils/events/filterEvents";
import { Checkbox } from 'primereact/checkbox';
import { Tooltip } from "react-tooltip";


export const FilterIndex = ({ filters = {}, submitFilters, initialFilters = [], isTestSeries, isTestSeriesAll, isSpecificTestSeries, isBoardPage, boardDetailsData, currentBoardId, testDeatils = [], isPreviousYearPage = false, isDiagnosticPage = false, isFullMockPage = false }: any) => {
    const navigation = useNavigate();
    const location = useLocation();
    const loginData = useAppSelector((state: any) => state.login);
    const coursePreferences = useAppSelector((state: any) => state.coursePreferences);
    const isLoggedIn = loginData?.isLoggedIn;
    const filterContainerRef = useRef<HTMLDivElement>(null);
    const coursePreferencesSnapshotRef = useRef<string | null>(null);
    const dispatch = useAppDispatch();
    const [checked, setChecked] = useState<boolean>(false)
    const [isPracticeTest, setIsPracticeTest] = useState<boolean>(false)
    const [isKeywordSearched, setIsKeywordSearched] = useState<boolean>(false);

    useEffect(() => {
        if (location.pathname === "/testseries" || location.pathname === "/testseries/all" || location.pathname === "/full-mock-testseries") {
            setIsPracticeTest(true);
        } else {
            setIsPracticeTest(false);
        }
    }, [location])


    let insitituteSwitchButton = '';
    switch (location.pathname) {
        case TestSereisRouteURL.DIAGNOSTIC_TEST_SERIES:
            insitituteSwitchButton = "readiness Check"
            break;
        case TestSereisRouteURL.TEST_SERIES:
            insitituteSwitchButton = "practice test"
            break;
        case TestSereisRouteURL.FULL_MOCK_TEST_SERIES:
            insitituteSwitchButton = "mock test"
            break;
        case TestSereisRouteURL.PREVIOUS_YEAR_MOCK_TEST_SERIES:
            insitituteSwitchButton = "previous year test"
            break;
        case `${TestSereisRouteURL.TEST_SERIES}/all`:
            insitituteSwitchButton = "practice test";
            break;
        default:
            insitituteSwitchButton = "practice test";

            break;
    }

    useEffect(() => {
        if (isLoggedIn) {
            getUserDetails().then((response: APIResponse) => {
                if (response.ResponseType === APIStatus.SUCCESS && response.data?.length > 0) {
                    dispatch(setSubscriptionData(response.data[0]));
                }
            });
        }
    }, [isLoggedIn, dispatch]);

    const { handleSubmit, handleChange, handleBlur, values, errors, touched, isValid, setFieldValue, setValues } = useFormik({
        initialValues: isTestSeries ? TestSeriesFiltersInitialvalue : FiltersInitialvalue,
        enableReinitialize: true,
        validationSchema: FiltersSchema,
        onSubmit: (e) => {
            setValues(e);
        },

    })

    const [Filters, setFilters] = useState<any>([]);
    const [keyword, setKeyword] = useState<string>("");

    // Listen for navigation events to reset keyword
    useEffect(() => {
        const handleResetKeyword = () => {
            setKeyword("");
        };

        filterEvents.on(FILTER_EVENTS.RESET_KEYWORD, handleResetKeyword);

        return () => {
            filterEvents.off(FILTER_EVENTS.RESET_KEYWORD, handleResetKeyword);
        };
    }, []);

    useEffect(() => {
        let filterConfig;
        if (isTestSeriesAll) {
            filterConfig = TEST_SERIES_ALL_FILTERS;
        } else if (isSpecificTestSeries) {
            filterConfig = SPECIFIC_TEST_SERIES_FILTERS;
        } else if (isPreviousYearPage) {
            filterConfig = PREVIOUS_YEAR_TEST_SERIES_FILTERS;
        } else if (isDiagnosticPage) {
            filterConfig = DIAGNOSTIC_TEST_SERIES_FILTERS;
        } else if (isFullMockPage) {
            filterConfig = FULL_MOCK_TEST_SERIES_FILTERS;
        } else if (isTestSeries) {
            filterConfig = TEST_SERIES_FILTERS;
        } else {
            filterConfig = BOARD_FILTERS;
        }

        // Dynamically set disabled state based on login status
        const updatedFilters = filterConfig.map(filter => {
            const updatedFilter = { ...filter };
            const keys = Object.keys(filter);
            keys.forEach(key => {
                if (key === FILTER_KEYS.LANGUAGE || key === FILTER_KEYS.BOARD || key === FILTER_KEYS.CLASS) {
                    let isDisabled = isLoggedIn;

                    // Disable board dropdown if route includes '/board'
                    if (key === FILTER_KEYS.BOARD && location.pathname.includes('/board')) {
                        isDisabled = true;
                    }

                    if (isBoardPage && key === FILTER_KEYS.CLASS) {
                        // Check if current board matches user's preferred board
                        const userBoardId = coursePreferences?.boardDetails?.[0]?.Id;
                        const isSameBoard = currentBoardId && userBoardId && String(currentBoardId) === String(userBoardId);

                        if (!isSameBoard) {
                            isDisabled = false;
                        }
                    }
                    updatedFilter[key] = {
                        ...filter[key],
                        disabled: isDisabled // Disabled when logged in, enabled when logged out
                    };
                }
            });
            return updatedFilter;
        });

        setFilters(updatedFilters);
    }, [isTestSeries, isTestSeriesAll, isLoggedIn, isSpecificTestSeries, isBoardPage, currentBoardId, coursePreferences, isPreviousYearPage, isDiagnosticPage, isFullMockPage]);

    const fetchClassList = async (boardId: number) => {
        try {
            const response: APIResponse = await getClassList({ boardId });
            if (response.ResponseType === APIStatus.SUCCESS && response.data) {
                submitFilters.updateClasses?.(response.data);
            }
        } catch (error) {
            console.error('Failed to fetch class list:', error);
        }
    };

    useEffect(() => {
        setInitialFilter();
    }, [initialFilters])

    // Style the filter labels after render
    useEffect(() => {
        const styleFilterLabels = () => {
            if (filterContainerRef.current) {
                const labels = filterContainerRef.current.querySelectorAll('.p-multiselect-label:not(.p-placeholder)');
                labels.forEach((label: any) => {
                    const text = label.textContent;
                    if (text && (text.includes('Subject:') || text.includes('Chapter:') || text.includes('Topic:') || text.includes('Difficulty Level:'))) {
                        const colonIndex = text.indexOf(':');
                        if (colonIndex > -1) {
                            const prefix = text.substring(0, colonIndex + 1);
                            const rest = text.substring(colonIndex + 1);
                            label.innerHTML = `<span class="filter-prefix">${prefix}</span>${rest}`;
                        }
                    }
                });
            }
        };

        // Run after a short delay to ensure DOM is updated
        const timer = setTimeout(styleFilterLabels, 100);
        return () => clearTimeout(timer);
    }, [values]); // Re-run when filter values change

    const setInitialFilter = () => {
        let values: any = {};
        // console.log('🔄 Setting initial filters:', initialFilters);
        initialFilters.forEach((element: any) => {
            let keys = Object.keys(element);
            keys.forEach((key: any) => {
                values[key] = element[key];
                if (key === 'languageId') {
                    // console.log('🌍 Language initial filter:', key, '=', element[key]);
                }
            })
        });
        // console.log('🎯 Final initial values:', values);
        setValues(values)
    }

    const getFieldType = (key: string) => {
        if (!Filters || !Filters.length) return null;
        for (const filterGroup of Filters) {
            if (filterGroup[key]) {
                return filterGroup[key].fieldType;
            }
        }
        return null;
    }

    const handleOnChange = (field: string, event: any, childs: any) => {
        let data: any = { ...values };
        if (isPracticeTest && checked) {
            data.previousYearCheck = 1;
        }
        if (keyword) {
            data.keyWord = keyword
            setIsKeywordSearched(true);
        }
        if (field == FILTER_KEYS.SOURCE) {
            // pass  source as array intead of string irrespective of the dropdown 
            data[field] = [event.target.value];
        } else {
            data[field] = event.target.value;
        }

        // Reset keyword input when board changes (but not from navigation menu)
        if (field === FILTER_KEYS.BOARD) {
            // Don't reset keyword when board changes via filter dropdown
            // setKeyword("");
        }

        if (childs && childs.length) {
            let initialFilterKeys: string[] = [];
            initialFilters.forEach((element: any) => {
                let keys = Object.keys(element);
                initialFilterKeys.push(...keys);
            });

            childs.forEach((child: string) => {
                // Skip clearing Language filter - it should persist independently
                if (child === FILTER_KEYS.LANGUAGE) {
                    return;
                }
                if (!initialFilterKeys.includes(child)) {
                    delete data[child];
                    const type = getFieldType(child);
                    if (type === FIELD_TYPE.MULTISELECT) {
                        setFieldValue(child, []);
                    } else {
                        setFieldValue(child, null);
                    }
                }
            });

            // Clear the lists of options for child filters in the parent state (except Language)
            if (submitFilters.clearChildLists) {
                const childsWithoutLanguage = childs.filter((child: string) => child !== FILTER_KEYS.LANGUAGE);
                submitFilters.clearChildLists(childsWithoutLanguage);
            }
        }

        // Handle board -> class population for logged out users
        if (field === FILTER_KEYS.BOARD && event.target.value?.Id && !isLoggedIn) {
            fetchClassList(event.target.value.Id);
        }

        // Handle test series dropdown population when class changes
        // if (field === FILTER_KEYS.CLASS && event.target.value?.Id && isTestSeries) {
        //     import('../TestDetails/services/TestDetails.service').then(({ getTestSeriesListByClass }) => {
        //         getTestSeriesListByClass(event.target.value.Id).then((response: any) => {
        //             if (response?.ResponseType === 'SUCCESS') {
        //                 // Trigger a callback to update parent filters
        //                 if (submitFilters.updateTestSeries) {
        //                     submitFilters.updateTestSeries(response.data || []);
        //                 }
        //             }
        //         }).catch((error) => {
        //             console.error('Error fetching test series:', error);
        //         });
        //     });
        // }

        // Handle class dropdown change on board pages - populate subjects
        if (field === FILTER_KEYS.CLASS && event.target.value?.Id && isBoardPage && boardDetailsData) {
            const selectedClassId = event.target.value.Id;
            const classData = boardDetailsData.find((item: any) => item.ClassId === selectedClassId);

            if (classData && classData.Subjects) {
                const subjects = classData.Subjects.map((subject: any) => ({
                    Id: subject.SubjectId,
                    Name: subject.SubjectName
                }));

                if (submitFilters.updateSubjects) {
                    submitFilters.updateSubjects(subjects);
                }
            }
        }

        // Handle chapter dropdown population when subject changes
        if (field === FILTER_KEYS.SUBJECT && event.target.value?.Id) {
            const subjectId = event.target.value.Id;
            if (subjectId === 'ALL') {
                if (submitFilters.updateChapters) {
                    submitFilters.updateChapters([]);
                }
                if (submitFilters.updateTopics) {
                    submitFilters.updateTopics([]);
                }
                setFieldValue(FILTER_KEYS.CHAPTER, []);
                setFieldValue(FILTER_KEYS.TOPIC, []);
            } else {
                const boardId = (values[FILTER_KEYS.BOARD] as any)?.Id || coursePreferences?.boardDetails?.[0]?.Id;
                const classId = (values[FILTER_KEYS.CLASS] as any)?.Id || coursePreferences?.classDetails?.[0]?.Id;

                if (boardId && classId && subjectId) {
                    import('../TestDetails/services/TestDetails.service').then(({ getChapterList }) => {
                        const params = {
                            boardId: boardId,
                            classId: classId,
                            subjectId: subjectId
                        };
                        getChapterList(params).then((response: any) => {
                            if (response?.ResponseType === 'SUCCESS') {
                                if (submitFilters.updateChapters) {
                                    submitFilters.updateChapters(response.data || []);
                                }
                            }
                        }).catch((error) => {
                            console.error('Error fetching chapters:', error);
                        });
                    });
                }
            }
        }

        // Handle topic dropdown population when chapter changes
        if (field === FILTER_KEYS.CHAPTER) {
            const selectedChapters = event.value;
            if (Array.isArray(selectedChapters) && selectedChapters.length > 0) {
                const chapterIds = selectedChapters.map((c: any) => c.Id).join(',');
                const boardId = (values[FILTER_KEYS.BOARD] as any)?.Id || coursePreferences?.boardDetails?.[0]?.Id;
                const classId = (values[FILTER_KEYS.CLASS] as any)?.Id || coursePreferences?.classDetails?.[0]?.Id;
                const subjectId = (values[FILTER_KEYS.SUBJECT] as any)?.Id;
                import('../TestDetails/services/TestDetails.service').then(({ getTopicList }) => {
                    const params: any = {
                        chapterId: chapterIds
                    };
                    if (boardId) params.boardId = boardId;
                    if (classId) params.classId = classId;
                    if (subjectId) params.subjectId = subjectId;
                    getTopicList(params).then((response: any) => {
                        if (response?.ResponseType === 'SUCCESS') {
                            if (submitFilters.updateTopics) {
                                submitFilters.updateTopics(response.data || []);
                            }
                        }
                    }).catch((error) => {
                        console.error('Error fetching topics:', error);
                    });
                });
            } else {
                if (submitFilters.updateTopics) {
                    submitFilters.updateTopics([]);
                }
            }
        }

        submitFilters(data)
    }

    const handleKeywordSearch = () => {
        const trimmedKeyword = keyword.trim();
        if (!trimmedKeyword) return;

        setIsKeywordSearched(true);
        submitFilters({
            ...values,
            keyWord: trimmedKeyword,
            previousYearCheck: checked ? 1 : 0,
        });
    };

    const handleKeywordKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            handleKeywordSearch();
        }
    };

    const handlePreviousYear = (e: any) => {
        setChecked(e.checked ?? false);
        const data = isKeywordSearched ? { ...values, keyWord: keyword.trim(), previousYearCheck: e.checked ? 1 : 0 } : { ...values, previousYearCheck: e.checked ? 1 : 0 };
        submitFilters(data);
    }

    const onClickClearFilter = () => {
        let initialValues: any = {};
        const keysToKeep = [FILTER_KEYS.BOARD, FILTER_KEYS.CLASS, FILTER_KEYS.LANGUAGE];
        if (isPreviousYearPage || isFullMockPage) {
            keysToKeep.push(FILTER_KEYS.SUBJECT);
        }

        initialFilters.forEach((element: any) => {
            let keys = Object.keys(element);
            keys.forEach((key: any) => {
                if (keysToKeep.includes(key)) {
                    initialValues[key] = element[key]
                }
            })
        });

        setKeyword("");
        setChecked(false);

        // Clear all dynamic filter lists (Chapters, Topics, etc.) in the parent state
        if (submitFilters.clearAllDependentFilters) {
            submitFilters.clearAllDependentFilters();
        }

        // Clear navigation state so subsequent renders don't pick up analysis IDs
        navigation(location.pathname, { replace: true, state: {} });

        if (isTestSeries) {
            setValues(initialValues);
            submitFilters(initialValues)
        } else {
            setValues(initialValues);
            submitFilters(initialValues);
        }
    }

    const handleTestSeriesChange = async () => {
        try {
            await setIabhyasTestSeries();
            const response = await getUserDetails();
            if (response.ResponseType === APIStatus.SUCCESS && response.data?.length > 0) {
                dispatch(setSubscriptionData(response.data[0]));
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        setKeyword("");
        setChecked(false);
    }, [location.pathname])

    const coursePreferencesKey = JSON.stringify({
        boardDetails: coursePreferences?.boardDetails?.map(({ Id, Name }: any) => ({ Id, Name })) || [],
        classDetails: coursePreferences?.classDetails?.map(({ Id, Name }: any) => ({ Id, Name })) || [],
        educationInterestDetails: coursePreferences?.educationInterestDetails?.map(({ Id, Name }: any) => ({ Id, Name })) || [],
        subjectDetails: coursePreferences?.subjectDetails?.map(({ Id, Name }: any) => ({ Id, Name })) || [],
    });

    useEffect(() => {
        if (coursePreferencesSnapshotRef.current === null) {
            coursePreferencesSnapshotRef.current = coursePreferencesKey;
            return;
        }

        if (coursePreferencesSnapshotRef.current !== coursePreferencesKey) {
            coursePreferencesSnapshotRef.current = coursePreferencesKey;
            window.location.reload();
        }
    }, [coursePreferencesKey]);

    return (
        <>
            <section className="filter-section ia-container px-3 py-6 m-auto">
                <div className="filter-head">
                    <div className="tw-flex tw-items-center tw-gap-4">
                        <div className="f-h-heading">Choose a Filter to Refine Results</div>
                        {loginData?.InstituteId && (
                            <button
                                className={loginData?.IabhyasSearch === 1 ? "ia-btn ia-btn-primary py-1 px-3 tw-text-sm" : "ia-btn ia-btn-outline-primary py-1 px-3 tw-text-sm"}
                                style={{ borderRadius: '4px' }}
                                onClick={handleTestSeriesChange}
                            >
                                {loginData?.IabhyasSearch === 1 ? `Click here to switch to institute ${insitituteSwitchButton} ` : `Click here to switch to iAbhyas ${insitituteSwitchButton} `}
                            </button>
                        )}
                    </div>
                </div>
                <form >

                    <div className="filter-dropdown-container" ref={filterContainerRef}>
                        {/* {filters.boardList && filters.boardList.length ? <Dropdown value={values.boardId} name="boardId" onChange={(event) => { handleChange(event), handleOnChange("boardId", event) }}
                            onBlur={handleBlur} options={filters.boardList} optionLabel="Name"
                            placeholder="Board" className="filter-dropdown" />
                            : ''}
                        {filters.classList && filters.classList.length ? <Dropdown value={values.classId} name="classId" onChange={(event) => { handleChange(event); handleOnChange("classId", event) }}
                            onBlur={handleBlur} options={filters.classList} optionLabel="Name"
                            placeholder="Class" className="filter-dropdown" /> : ''}
                        {filters.subjectList && filters.subjectList.length ? <Dropdown value={values.subjectId} name="subjectId" onChange={(event) => { handleChange(event); handleOnChange("subjectId", event) }}
                            onBlur={handleBlur} options={filters.subjectList} optionLabel="Name"
                            placeholder="Subject" className="filter-dropdown" /> : ''}
                        {filters.chapterList && filters.chapterList.length ? <MultiSelect value={values.chapterId} name="chapterId" onChange={(event) => { handleChange(event); handleOnChange("chapterId", event) }}
                            onBlur={handleBlur} options={filters.chapterList} optionLabel="Name"
                            placeholder="Chapter" className="filter-dropdown" filter={true} filterPlaceholder={'Search'}
                            maxSelectedLabels={1} selectedItemsLabel={`Chapter ${values.chapterId && values.chapterId.length ? values.chapterId[0]['Name'] : ''} {0}+`} /> : ''}
                        {filters.topicList && filters.topicList.length ? <MultiSelect value={values.topicId} name="topicId" onChange={(event) => { handleChange(event); handleOnChange("topicId", event) }}
                            onBlur={handleBlur} options={filters.topicList} optionLabel="Name"
                            placeholder="Topic" className="filter-dropdown" filter={true} filterPlaceholder={'Search'}
                            maxSelectedLabels={1} selectedItemsLabel={`Topic ${values.topicId && values.topicId.length ? values.topicId[0]['Name'] : ''}{0}+`} />
                            : ''}
                        {filters.difficultyList && filters.difficultyList.length ? <MultiSelect value={values.difficultyLevelId} name="difficultyLevelId" onChange={(event) => { handleChange(event); handleOnChange("difficultyLevelId", event) }}
                            onBlur={handleBlur} options={filters.difficultyList} optionLabel="Name"
                            placeholder="Difficulty Level" className="filter-dropdown" filter={true} filterPlaceholder={'Search'}
                            maxSelectedLabels={1} selectedItemsLabel={`Difficulty Level ${values.difficultyLevelId && values.difficultyLevelId.length ? values.difficultyLevelId[0]['Name'] : ''}{0}+`} />
                            : ''}
                        {filters.languageList && filters.languageList.length ? <Dropdown value={values.languageId} name="languageId" onChange={(event) => { handleChange(event); handleOnChange("languageId", event) }}
                            onBlur={handleBlur} options={filters.languageList} optionLabel="Name"
                            placeholder="Language" className="filter-dropdown" />
                            : ''} */}
                        {
                            Filters && Filters.length && Filters.map((filter: any, index: number) => {
                                return (
                                    Object.keys(filter).map((fil: any) => {
                                        let isParentHasValue: boolean = false;
                                        if (filter[fil]['parents'] && filter[fil]['parents'].length) {
                                            filter[fil]['parents'].forEach((pt: string) => {
                                                // Check if parent value exists and is valid
                                                // For objects (dropdown): check if it has an Id property
                                                // For arrays (multiselect): check if array has length > 0
                                                if (values[pt]) {
                                                    if (Array.isArray(values[pt])) {
                                                        // For multiselect fields
                                                        const arrayValue = values[pt] as any[];
                                                        if (arrayValue.length > 0) {
                                                            isParentHasValue = true;
                                                        }
                                                    } else if (typeof values[pt] === 'object' && (values[pt] as any).Id) {
                                                        // For dropdown fields
                                                        if (pt === FILTER_KEYS.SUBJECT && (values[pt] as any).Id === 'ALL') {
                                                            // 'ALL' subject means no specific subject selected for chapter/topic filtering
                                                        } else {
                                                            isParentHasValue = true;
                                                        }
                                                    }
                                                }
                                            });
                                        } else {
                                            isParentHasValue = true;
                                        }

                                        let dropdownOptions = filters[filter[fil]['list']] || [];
                                        if (fil === FILTER_KEYS.SUBJECT && (isPreviousYearPage || isFullMockPage) && dropdownOptions.length > 0 && !dropdownOptions.some((o: any) => o.Id === 'ALL')) {
                                            dropdownOptions = [{ Id: 'ALL', Name: 'All Subject' }, ...dropdownOptions];
                                        }

                                        return (
                                            filter[fil].fieldType == FIELD_TYPE.DROPDOWN && isParentHasValue ?
                                                <Dropdown key={index} value={filter[fil]['key'] == FILTER_KEYS.SOURCE ? values[filter[fil]['key']] : values[filter[fil]['key']]} name={filter[fil].name} onChange={(event) => { handleChange(event), handleOnChange(filter[fil].key, event, filter[fil]['childs']) }}
                                                    onBlur={handleBlur} options={dropdownOptions} optionLabel="Name" dataKey="Id"
                                                    placeholder={filter[fil]['key'] === FILTER_KEYS.LANGUAGE && isLoggedIn ? (loginData?.LanguageName || filter[fil].placeholder) : filter[fil].placeholder} className="filter-dropdown" filter={true} disabled={filter[fil].disabled}
                                                    emptyMessage={`No ${filter[fil].placeholder.toLowerCase()}s found`} />
                                                : filter[fil].fieldType == FIELD_TYPE.MULTISELECT && filter[fil]['key'] == FILTER_KEYS.LANGUAGE && isParentHasValue ?
                                                    <MultiSelect key={index} value={values[filter[fil]['key']]} name={filter[fil].name} onChange={(event) => { handleChange(event); handleOnChange(filter[fil].key, event, filter[fil]['childs']) }}
                                                        onBlur={handleBlur}
                                                        options={filters[filter[fil]['list']] && filters[filter[fil]['list']].length > 0 ? filters[filter[fil]['list']] : [{ Id: 'empty', Name: `No ${filter[fil].placeholder.toLowerCase()}s found` }]}
                                                        optionLabel="Name" optionDisabled={(option) => option.Id === 'empty'}
                                                        placeholder={filter[fil].placeholder} className="filter-dropdown" filter={true} filterPlaceholder={'Search'}
                                                        maxSelectedLabels={3}
                                                        selectedItemTemplate={(option) => {
                                                            // console.log('🏷️ Selected item template:', option);
                                                            return option?.Name || 'Language';
                                                        }}
                                                        disabled={filter[fil].disabled}
                                                        emptyFilterMessage={`No ${filter[fil].placeholder.toLowerCase()}s found`} />
                                                    : filter[fil].fieldType == FIELD_TYPE.MULTISELECT && filter[fil]['key'] != FILTER_KEYS.LANGUAGE && isParentHasValue ?
                                                        <MultiSelect
                                                            key={index}
                                                            value={values[filter[fil]['key']]
                                                            }
                                                            name={filter[fil].name}
                                                            onChange={(event) => { handleChange(event); handleOnChange(filter[fil].key, event, filter[fil]['childs']) }}
                                                            onBlur={handleBlur}
                                                            options={filters[filter[fil]['list']] && filters[filter[fil]['list']].length > 0 ? filters[filter[fil]['list']] : [{ Id: 'empty', Name: `No ${filter[fil].placeholder.toLowerCase()}s found` }]}
                                                            optionLabel="Name"
                                                            optionDisabled={(option) => option.Id === 'empty'}
                                                            placeholder={filter[fil].placeholder}
                                                            className="filter-dropdown"
                                                            filter={true}
                                                            filterPlaceholder={'Search'}
                                                            maxSelectedLabels={0}
                                                            selectedItemsLabel={
                                                                `${filter[fil].placeholder}: ${Array.isArray(values[filter[fil]['key']]) && (values[filter[fil]['key']] as any[]).length
                                                                    ? ((values[filter[fil]['key']] as any[])[0]['Name'].length > 3
                                                                        ? (values[filter[fil]['key']] as any[])[0]['Name'].substring(0, 4) + '...'
                                                                        : (values[filter[fil]['key']] as any[])[0]['Name'])
                                                                    : ''}${Array.isArray(values[filter[fil]['key']]) && (values[filter[fil]['key']] as any[]).length > 1
                                                                        ? ', +' + ((values[filter[fil]['key']] as any[]).length - 1)
                                                                        : ''}`
                                                            }
                                                            disabled={filter[fil].disabled}
                                                            emptyFilterMessage={`No ${filter[fil].placeholder.toLowerCase()}s found`} />
                                                        : ''
                                        )
                                    })
                                )
                            })
                        }

                        <div className="keyword-search-wrapper">
                            <span className="p-input-icon-right">
                                <InputText
                                    value={keyword}
                                    onChange={(e) => setKeyword(e.target.value)}
                                    onKeyPress={handleKeywordKeyPress}
                                    placeholder="Test Series Search"
                                    className="keyword-search-input"
                                />
                                <i className="pi pi-search" onClick={handleKeywordSearch} style={{ cursor: 'pointer' }} />
                            </span>
                        </div>
                        {
                            isPracticeTest && <div className="tw-flex gap-2">
                                <div className="tw-flex gap-2 previous-check" data-tooltip-id="previousCheck" data-tooltip-content="Only Previous Year Questions">
                                    <Checkbox
                                        inputId="previousYear"
                                        checked={checked}
                                        onChange={(e) => handlePreviousYear(e)}
                                    />
                                    <label className="cursor-pointer" htmlFor="previousYear">PYQ</label>
                                </div>
                                <Tooltip id="previousCheck" place="top" style={{ fontSize: '12px', padding: '4px 8px' }} />


                            </div>
                        }


                        <a className="ia-btn ia-btn-outline-primary tw-text-lg py-1 px-2" onClick={onClickClearFilter} >
                            <svg width="16" height="17" viewBox="0 0 16 17" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_3413_3245)">
                                    <path d="M3.64216 3.45501C4.85187 2.40679 6.39949 1.83078 8.00016 1.83301C11.6822 1.83301 14.6668 4.81768 14.6668 8.49968C14.6668 9.92368 14.2202 11.2437 13.4602 12.3263L11.3335 8.49968H13.3335C13.3336 7.4541 13.0263 6.43155 12.4499 5.55919C11.8735 4.68682 11.0535 4.00312 10.0916 3.5931C9.12978 3.18307 8.06864 3.06482 7.04013 3.25303C6.01163 3.44124 5.06113 3.92761 4.30683 4.65168L3.64216 3.45501ZM12.3582 13.5443C11.1485 14.5926 9.60084 15.1686 8.00016 15.1663C4.31816 15.1663 1.3335 12.1817 1.3335 8.49968C1.3335 7.07568 1.78016 5.75568 2.54016 4.67301L4.66683 8.49968H2.66683C2.66674 9.54527 2.974 10.5678 3.55039 11.4402C4.12678 12.3125 4.94687 12.9962 5.90871 13.4063C6.87054 13.8163 7.93169 13.9345 8.96019 13.7463C9.9887 13.5581 10.9392 13.0717 11.6935 12.3477L12.3582 13.5443Z" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_3413_3245">
                                        <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
                                    </clipPath>
                                </defs>
                            </svg>
                            Clear Filter</a>
                    </div>
                </form>
            </section>

        </>
    )
}